<template>
  <div class="mt-5" v-if="product">
    <h2>Produkt-koder for {{ product.product_info.name }}</h2>
    <p>Her kan du laste opp interne koder som associeres med ett innlöst verdibevis</p>

    <form class="mt-5">
      <div class="form-group">
        <label>Disse koder er gyldige mellom disse datoer</label>
        <v-date-picker mode="range" v-model="selectedDate" show-caps> </v-date-picker>
      </div>
      <div class="row">
        <div class="col">
          <label>Koder: (1 per rad)</label>
          <textarea class="form-control" v-model="codes"></textarea>
          <div class="form-group mt-3">
            <button @click.prevent="submitCodes()" class="btn btn-success">Lagre koder</button>
          </div>
        </div>
        <div class="col">
          <label>Last opp CSV</label>
          <input
            type="file"
            class="form-control"
            id="file"
            ref="file"
            v-on:change="handleFileUpload()"
          />
          <div class="form-group mt-3">
            <button @click.prevent="submitFile()" class="btn btn-success">
              Last opp & lagre koder
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      codes: '',
      product: null,
      selectedDate: null,
      file: '',
      urlPrefix: process.env.VUE_APP_API_URL,
    };
  },
  mounted() {
    this.getProducts();
    this.product = this.productById(this.$route.params.product_id);
    console.log(this.$route.params.product_id);
  },
  computed: {
    ...mapGetters({
      productById: 'products/productById',
      activeProducts: 'products/activeProducts',
    }),
  },
  methods: {
    submitCodes() {
      const url = `${this.urlPrefix}/products/${this.product.product_info_id}/codes`;
      axios
        .post(url, {
          codes: this.codes,
          valid_from: this.selectedDate.start,
          valid_to: this.selectedDate.end,
        })
        .then(function() {
          this.$bvToast.toast(`Koderna ble lastet opp`, {
            variant: 'success',
            title: 'Koderna ble lastet opp og lagret!',
            autoHideDelay: 5000,
          });
        })
        .catch(function() {
          console.log('FAILURE!!');
        });
    },
    submitFile() {
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('valid_from', '' + this.selectedDate.start.toISOString());
      formData.append('valid_to', this.selectedDate.end.toISOString());

      const url = `${this.urlPrefix}/products/${this.product.product_info_id}/codes/csv`;

      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(function() {
          this.$bvToast.toast(`Koderna ble lastet opp`, {
            variant: 'success',
            title: 'Koderna ble lastet opp og lagret!',
            autoHideDelay: 5000,
          });
        })
        .catch(function() {
          console.log('FAILURE!!');
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    ...mapActions({
      getProducts: 'products/getProducts',
    }),
  },
};
</script>

<style>
</style>
